<template>
  <div class="filter-select">
    <div class="filter-select__head">
      <label class="filter-label">{{ title }}</label>
      <b-button
        v-if="selectAll && options.length"
        size="sm"
        variant="link"
        class="filter-select__all"
        @click="$emit('input', options.slice())"
      >
        Select all
      </b-button>
    </div>
    <v-select
      :options="options"
      :value="value"
      :multiple="true"
      :label="label"
      :placeholder="placeholder"
      :close-on-select="false"
      @input="$emit('input', $event)"
    >
      <!-- Show only the first pick plus a count, so the control stays one
           line tall however much is selected (e.g. after Select all). -->
      <template #selected-option-container="{ option, deselect }">
        <span v-if="isFirst(option)" class="vs__selected">
          <span class="filter-select__first">{{ option[label] }}</span>
          <button type="button" class="vs__deselect" :title="`Deselect ${option[label]}`" @click.stop="deselect(option)">
            <feather-icon icon="XIcon" size="12" />
          </button>
        </span>
        <span v-if="isFirst(option) && value.length > 1" class="filter-select__more">+{{ value.length - 1 }}</span>
      </template>
    </v-select>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import vSelect from 'vue-select'

// Multi-select for the report filter bars: compact chip display plus an
// optional "Select all" link beside the label.
export default {
  name: 'FilterSelect',
  components: { BButton, vSelect },
  props: {
    title: { type: String, required: true },
    options: { type: Array, default: () => [] },
    value: { type: Array, default: () => [] },
    label: { type: String, default: 'label' },
    placeholder: { type: String, default: 'All' },
    selectAll: { type: Boolean, default: false },
  },
  methods: {
    isFirst(option) {
      return this.value.length > 0 && this.value[0] === option
    },
  },
}
</script>

<style scoped>
.filter-select__head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.25rem;
}
.filter-label {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  color: #6e6b7b;
  margin-bottom: 0.25rem;
  white-space: nowrap;
}
.filter-select__all {
  padding: 0;
  font-size: 0.72rem;
  white-space: nowrap;
}
.filter-select ::v-deep .vs__selected-options {
  flex-wrap: nowrap;
  min-width: 0;
}
.filter-select ::v-deep .vs__selected {
  min-width: 0;
  max-width: 100%;
}
.filter-select__first {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.filter-select__more {
  display: inline-flex;
  align-items: center;
  margin: 4px 2px 0;
  padding: 0 0.4rem;
  border-radius: 999px;
  background: rgba(115, 103, 240, 0.12);
  color: #7367f0;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}
</style>
